<template>
  <grid id="gatewayModemsGrid"
        :title="$t('g-modems:modems')"
        :columns="columns"
        :paginated-dto="modems"
        :pagination="false"
        :disabled="!$store.getters.bscFeature(gateway, 'modem')"
        @load="getModems"
  />
</template>

<script>
import { isEmpty } from 'lodash-es'
import to from '@/modules/await-to-js'

export default {
  props: {
    gateway: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      getting: false,
      modems: {},

      columns: [
        { id: 'serialNumber', text: this.$t('g-modems:serialNumber') },
        { id: 'location', text: this.$t('g-modems:location') },
        { id: 'lanRadioType', text: this.$t('g-modems:type') },
        { id: 'lanRadioHwVersion', text: this.$t('g-modems:hwVersion') },
        { id: 'lanRadioSwVersion', text: this.$t('g-modems:swVersion') },
        { id: 'lanRadioAntennaNumber', text: this.$t('g-modems:nbAntenna') },
        { id: 'lanRadioCentralFrequency', text: this.$t('g-modems:centralFrequency'), formatter: dto => this.$utils.formatFrequency(dto.lanRadioCentralFrequency) },
        { id: 'lanRadioRfFrontInputPathNumber', text: this.$t('g-modems:nbRadiopathFront') },
        { id: 'lanRadioRfPathNumber', text: this.$t('g-modems:nbRadiopath') },
        { id: 'lanRadioPathWidth', text: this.$t('g-modems:radiopathWidth'), formatter: dto => this.$utils.formatFrequency(dto.lanRadioPathWidth * 1000) },
        { id: 'lanRadioMinTxFrequency', text: this.$t('g-modems:minTxFrequency'), formatter: dto => this.$utils.formatFrequency(dto.lanRadioMinTxFrequency) },
        { id: 'lanRadioMaxTxFrequency', text: this.$t('g-modems:maxTxFrequency'), formatter: dto => this.$utils.formatFrequency(dto.lanRadioMaxTxFrequency) },
        { id: 'lanRadioMinRxFrequency', text: this.$t('g-modems:minRxFrequency'), formatter: dto => this.$utils.formatFrequency(dto.lanRadioMinRxFrequency) },
        { id: 'lanRadioMaxRxFrequency', text: this.$t('g-modems:maxRxFrequency'), formatter: dto => this.$utils.formatFrequency(dto.lanRadioMaxRxFrequency) }
      ]
    }
  },

  watch: {
    gateway (newGateway, oldGateway) {
      // Do not refresh is we are olready getting data
      if (this.getting) return

      // Object change, but gateway does not...
      if (isEmpty(this.gateway) || newGateway.eui === oldGateway.eui) return

      // Reset modems list when gateway change
      this.modems = {}

      this.getModems()
    }
  },

  created () {
    this.getModems()
  },

  methods: {
    async getModems (options) {
      // If gateway is disconnected, do not ask for modem list
      if (isEmpty(this.gateway) || !this.gateway.connection) return
      // If we already have a modem list (even if empty), do not ask twice
      if (!isEmpty(this.modems) && isEmpty(options)) return
      // If we have some options and the refresh is forced from reload button, do not ask twice
      if (!isEmpty(options) && !options.fromReload) return

      this.getting = true

      let error, response
      [error, response] = await to(this.$api.getGatewayModems(this.gateway))

      if (error || !response) {
        this.getting = false
        return
      }

      this.modems = response.data
    }
  }
}
</script>
